// src/pages/ImamMahdi.jsx
import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const ImamMahdi = () => {
  return (
    <>
      <Helmet>
        <title>Imam Mahdi (ajtf) – The Awaited Saviour | Ziyarat Guide</title>
        <meta
          name="description"
          content="Learn about Imam Mahdi (ajtf) — his lineage, occultation, titles, and promised return to bring global justice. Explore the prayers and teachings that connect believers to the awaited Imam."
        />
        <meta property="og:title" content="Imam Mahdi (ajtf) – The Awaited Saviour | Ziyarat Guide" />
        <meta
          property="og:description"
          content="Discover the story of Imam Mahdi (ajtf), the twelfth Imam. Understand his lineage, occultation, and the universal message of justice he will bring."
        />
        <meta
          property="og:image"
          content="https://ziyaratguide.com/wp-content/uploads/2025/07/third-His-role-as-the-ultimate-reformer-.png"
        />
        <meta property="og:type" content="article" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <div className="imam-page">
        <div className="imam-content">
          <h1 className="page-title">Who is Imam Mahdi?</h1>
          <img
            src="https://ziyaratguide.com/wp-content/uploads/2025/07/third-His-role-as-the-ultimate-reformer-.png"
            alt="Imam Mahdi"
            className="imam-image"
          />

          <section className="content-section">
            <h2>His Identity and Lineage</h2>
            <p>
              Imam Mahdi (peace be upon him), also known as Muhammad ibn Hasan
              al-Askari, is the 12th Imam in the line of divinely appointed
              successors from the family of Prophet Muhammad (peace be upon him
              and his family).
            </p>
            <p>
              He was born in 255 AH (868 CE) in Samarra, Iraq.
              <br />
              <strong>Father:</strong> Imam Hasan al-Askari (the 11th Imam),
              descendant of Imam Ali and Lady Fatima (daughter of Prophet
              Muhammad).
              <br />
              <strong>Mother:</strong> Lady Narjis Khatun, from a Roman lineage,
              became part of Ahlulbayt by divine plan.
            </p>
          </section>

          <section className="content-section">
            <h2>His Names and Titles</h2>
            <ul>
              <li><strong>Al-Mahdi (المهدي):</strong> The Guided One.</li>
              <li><strong>Sahib al-Zaman (صاحب الزمان):</strong> Master of the Age.</li>
              <li><strong>Al-Muntadhar (المنتظر):</strong> The Awaited.</li>
              <li><strong>Al-Qa’im (القائم):</strong> The one who will stand up for justice.</li>
            </ul>
            <p>These titles reflect the community’s love and longing for their Imam.</p>
          </section>

          <section className="content-section">
            <h2>The Concept of Occultation (Ghaybah)</h2>
            <p>
              After his father’s martyrdom in 260 AH (874 CE), Imam Mahdi entered
              occultation. He is hidden from view but remains alive, guiding
              affairs unseen.
            </p>
            <ul>
              <li>
                <strong>Minor Occultation:</strong> ~69 years. Communication
                through four appointed deputies (the “Four Safeers”).
              </li>
              <li>
                <strong>Major Occultation:</strong> From 329 AH (941 CE) till
                today. No appointed deputies, guidance through qualified scholars
                (Maraji’).
              </li>
            </ul>
            <p>
              <strong>Why the Occultation?</strong>
              <br />– To protect his life from tyrants.
              <br />– To test the faith and patience of believers.
              <br />– To prepare purified companions for his return.
            </p>
            <p>
              Imam Mahdi is aware of his followers and intercedes for them. Many
              believers send him salaam daily.
            </p>
          </section>

          <section className="content-section">
            <h2>The Awaited Return</h2>
            <p>
              Shia Muslims believe Imam Mahdi will return when Allah wills, to
              fill the earth with justice after it has been overwhelmed by
              oppression. This belief is supported by narrations from both Sunni
              and Shia sources.
            </p>
          </section>

          <section className="content-section">
            <h2>In Daily Life</h2>
            <p>Imam Mahdi is a present, caring leader. Believers connect with him through prayers like:</p>
            <ul>
              <li><strong>Dua Al-Ahad:</strong> Renewing allegiance every morning.</li>
              <li><strong>Dua Nudba:</strong> Longing for his return (Fridays).</li>
              <li><strong>Ziyarat Ale Yasin:</strong> Greeting Imam Mahdi.</li>
            </ul>
          </section>

          <section className="content-section">
            <h2>In Summary</h2>
            <p>
              Imam Mahdi (aj) is the twelfth divinely appointed Imam, the son of
              Imam Hasan al-Askari and Narjis Khatun, currently in occultation by
              Allah’s command.
            </p>
            <p>
              He bears titles such as Al-Mahdi, Sahib al-Zaman, Al-Muntadhar and
              Al-Qa’im, reflecting his role as the awaited saviour who will return
              to establish global justice.
            </p>
            <p>
              Awaiting him is not passive – it is a daily act of spiritual
              preparation, truthfulness, and striving for justice, so that when he
              comes, we may be among his loyal supporters.
            </p>
          </section>
        </div>

        {/* Sidebar Navigation */}
        <aside className="imam-sidebar">
          <h2>Explore More</h2>
          <ul>
            <li>
              <Link to="/imam-mahdi/described-in-quran-hadith">Described In Quran & Hadith</Link>
            </li>
            <li><Link to="/imam-mahdi/how-to-talk">How To Talk</Link></li>
            <li><Link to="/imam-mahdi/impact-appearance">Impact of His Appearance</Link></li>
            <li><Link to="/imam-mahdi/misconceptions">Misconceptions</Link></li>
            <li><Link to="/imam-mahdi/practices-allegiance">Practices & Allegiance</Link></li>
            <li><Link to="/imam-mahdi/reflections-stories">Reflections & Stories</Link></li>
            <li><Link to="/imam-mahdi/return">Return</Link></li>
            <li><Link to="/imam-mahdi/signs-reappearance">Signs of Reappearance</Link></li>
            <li><Link to="/imam-mahdi/supporters">Supporters</Link></li>
            <li><Link to="/imam-mahdi/ultimate-reformer">The Ultimate Reformer</Link></li>
            <li><Link to="/imam-mahdi/why-occultation">Why Occultation</Link></li>
          </ul>
        </aside>
      </div>
    </>
  );
};

export default ImamMahdi;
